import isDefinedAndNonNull from './isDefinedAndNonNull';

export default function sanitizePotentialNumber(val: any): number | null {
  if (!isDefinedAndNonNull(val)) {
    return null;
  }

  if (typeof val === 'string') {
    const sanitizedString = val.replace(/,/g, ''); // remove commas
    return isNaN(Number(sanitizedString)) ? null : Number(sanitizedString);
  } else if (typeof val === 'number') {
    return val;
  } else {
    return null;
  }
}
